import { useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';

// TODO: Re-enable once My Learning changes are added
// import { ACRouterLink } from 'academy-common-lib/components/ACRouterLink';
import { CardsSection } from 'academy-common-lib/features/cardsSection/components/CardsSection';
import { useLearningEvents } from 'academy-common-lib/features/liveEvents/liveEventQueries';
import { LiveEventFooter } from 'academy-common-lib/features/liveEvents/components/LiveEventFooter';
import { toLiveEventCardModel } from 'academy-common-lib/features/liveEvents/toLiveEventCardModel';
import { unwrapChirpError } from 'academy-common-lib/utils/DataFetchingClient';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import OnboardingSectionLayout from './OnboardingSectionLayout';
import { orderEventsByWorkshopIds } from 'academy-common-lib/features/liveEvents/nextStepWorkshopIds';
import { ACADEMY_ONBOARDING_SECTION_IDS } from '../constants/sectionAnchors';

// TODO: Re-enable once My Learning changes are added
// import { MYLEARNING_URL_FRAGMENT } from '../../../constants/Navigation.legacy';
// const VIEW_REGISTERED_EVENTS_TO = `${MYLEARNING_URL_FRAGMENT}?contentType=LIVE_EVENT`;
import { jsx as _jsx } from "react/jsx-runtime";
const PAGE_SIZE = 4;
const ALL_EVENTS_PAGE_LENGTH = 100;
const LiveEventSection = () => {
  const {
    isMobile
  } = useMediaQuery();
  const [pageStart, setPageStart] = useState(0);
  const [maxCards, setMaxCards] = useState(PAGE_SIZE);
  const pageSize = isMobile ? PAGE_SIZE : maxCards;
  const {
    learningEvents,
    learningEventsLoading,
    learningEventsError
  } = useLearningEvents({
    pageLength: ALL_EVENTS_PAGE_LENGTH
  });
  const eventsByCardId = useMemo(() => {
    const result = new Map();
    learningEvents.forEach(event => result.set(event.id, event));
    return result;
  }, [learningEvents]);

  // TODO: Replace this client-side ordering once the BE supports series
  // grouping for live events.
  const cardModels = useMemo(() => orderEventsByWorkshopIds(learningEvents).map(toLiveEventCardModel), [learningEvents]);
  const visibleCardModels = cardModels.slice(pageStart, pageStart + pageSize);
  const handleClickNext = () => setPageStart(start => start + pageSize);
  const handleClickPrevious = () => setPageStart(start => Math.max(0, start - pageSize));
  const showNext = pageStart + pageSize < cardModels.length;
  const showPrevious = pageStart > 0;
  const renderFooter = cardModel => {
    const liveEventModel = cardModel;
    const event = eventsByCardId.get(liveEventModel.id);
    if (!event) return null;
    return /*#__PURE__*/_jsx(LiveEventFooter, {
      attended: event.attended,
      eventType: event.eventType,
      nextRegisteredSession: event.nextRegisteredSession,
      nextUpcomingEventSession: event.nextUpcomingEventSession
    });
  };
  return /*#__PURE__*/_jsx(OnboardingSectionLayout, {
    id: ACADEMY_ONBOARDING_SECTION_IDS.liveEvents,
    paddingBlockEnd: "600",
    paddingBlockStart: "600",
    children: /*#__PURE__*/_jsx(CardsSection, {
      appearsIn: "academy-onboarding-live-event",
      content: visibleCardModels,
      description: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        gap: "200",
        children: /*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.academyOnboarding.liveEvent.description"
          })
        })
      }),
      direction: isMobile ? 'column' : 'row',
      error: unwrapChirpError(learningEventsError),
      errorMarker: "ACADEMY_ONBOARDING_LIVE_EVENTS_API_ERROR",
      header: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.academyOnboarding.liveEvent.title"
      }),
      isLoading: learningEventsLoading,
      maxSkeletonListLength: 3,
      navMarker: "ACADEMY_ONBOARDING_LIVE_EVENTS_LOADED",
      onClickNext: handleClickNext,
      onClickPrevious: handleClickPrevious,
      overviewType: "academy-onboarding-live-event",
      renderFooter: renderFooter,
      setMaxCards: isMobile ? undefined : setMaxCards,
      showNext: showNext,
      showOverview: true,
      showPrevious: showPrevious,
      size: isMobile ? 'small' : 'large'
    })
  });
};
export default LiveEventSection;